const originalTheme = {
  common: {
    titleColor: "#000000",
    subTitleColor: "#000000",
    iconColor: "#000000A6",
    nextColor: "#00E09D",
  },
  size: {
    dotColor: "#FF915E",
    btnBgColor: "#2E9DFF",
  },
  calendar: {
    dotColor: "#FF915E",
    panelBgColor: "#000000",
    todayBgColor: "#FCF8E3",
    selectedBgColor: "#48D0E9",
  },
  time: {
    dotColor: "#FF915E",
    dotSmallColor: "#FF915E",
    timeBtnColor: "#2E9DFF",
  },
  customer: {
    dotColor: "#46D7EA",
  },
};

export const testTheme = {
  common: {
    titleColor: "#000000",
    titleColor: "red",
    subTitleColor: "#000000",
    subTitleColor: "#eee",
    iconColor: "#000000A6",
    iconColor: "#ccc",
    nextColor: "#00E09D",
    nextColor: "#aaa",
    logo: "https://element-plus.gitee.io/images/element-plus-logo.svg",
  },
  size: {
    dotColor: "#FF915E",
    dotColor: "#bbb",
    btnBgColor: "#2E9DFF",
    btnBgColor: "#aaa",
  },
  calendar: {
    dotColor: "#FF915E",
    dotColor: "#333",
    panelBgColor: "#000000",
    panelBgColor: "red",
    todayBgColor: "#FCF8E3",
    todayBgColor: "yellow",
    selectedBgColor: "#48D0E9",
    selectedBgColor: "#eee",
  },
  time: {
    dotColor: "#FF915E",
    dotColor: "#eee",
    dotSmallColor: "#FF915E",
    dotSmallColor: "#ccc",
    timeBtnColor: "#2E9DFF",
    timeBtnColor: "#aaa",
  },
  customer: {
    dotColor: "#46D7EA",
    dotColor: "#ccc",
  },
};

export default originalTheme;



// WEBPACK FOOTER //
// ./src/assets/originalTheme.js